import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core'

@Component({
  selector: 'pai-switching-chevron',
  standalone: true,
  templateUrl: './switching-chevron.component.html',
  styleUrls: ['./switching-chevron.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'aria-hidden': 'true',
  },
})
export class SwitchingChevronComponent {
  readonly pointingDown = input<boolean>()

  readonly size = input<number>(24)
  readonly animationDur = input<number>(400)
  readonly finalStrokeWidth = input<number>(2)

  protected readonly pointingUp = computed(() => !this.pointingDown())
  protected readonly strokeWidth = computed(() => (this.finalStrokeWidth() / this.size()) * 24)
}
